module.exports = __webpack_public_path__ + "img/collaboration-infra.99a62d82.png";